import { useEffect, useMemo, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import {
  getUsersForCurrentPage,
  changeRowsNumber,
  searchForTeamMembers,
  deleteUser,
  getTeamMembers
} from '../../../../redux/slices/accounts/team/team';
import { Button, OverlayTrigger, Stack, Tooltip } from 'react-bootstrap';
import Symbol from '../../../utils/symbol';
import RoleIndicator from '../../../utils/roleIndicator';
import SearchField from '../../../utils/datatable/searchField';
import { COCKPIT } from '../../../../config/constants';
import IsLoadingIndicator from '../../../isLoadingIndicator';
import RolePermissions from '../../../utils/roleIndicator/rolePermissions';
import { useNavigate } from 'react-router-dom';
import { PATH_PAGE } from '../../../../routes/paths';
import { fetchSubscriptionData } from '../../../../redux/slices/subscriptionManagement/subscriptionManagement';
import { T, useTranslate } from '@tolgee/react';
import { Toaster, toast } from 'react-hot-toast';
import { useLocales } from '../../../../locales';
import { LomavisCopyableText } from '../../../../lomavisSharedUi/atoms/typography/LomavisCopyableText';
export function TeamManagementTable({ type }) {
  const { currentLang } = useLocales();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const userDeletedCallback = () => {
    toast.success(t('accounts.team.table.user_deleted'), {
      position: 'top-right'
    });
    dispatch(fetchSubscriptionData());
  };
  const columns = [
    {
      name: t('accounts.team.table.name'),
      show: true,
      key: 'first_name,last_name',
      sortable: true,
      grow: 2,
      selector: (row) => (
        <Stack direction={'horizontal'} gap={3} style={{ padding: 4 }}>
          <div
            className="cursor-pointer"
            onClick={() => {
        
                navigate(PATH_PAGE.edit_user.replace(':uuid', row.uuid));
             
            }}
          >
            <div className="p-0 m-0">
              <Symbol
                initials={`${row.first_name[0] || 'U'}${
                  row.last_name[0] || 'N'
                }`}
              />
            </div>
          </div>

          <div
            className="d-flex justify-content-start flex-column"
            onClick={() => {
        
                navigate(PATH_PAGE.edit_user.replace(':uuid', row.uuid));

            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  <>
                    <p className="text-gray-800 fw-bold text-hover-primary mb-1 fs-6 cursor-pointer">
                      {`${row.first_name} ${row.last_name}`}
                    </p>
                    <span className="text-gray-400 fw-bold d-block fs-7">
                      {row.email}
                    </span>
                  </>
                </Tooltip>
              }
            >
              <div>
                <a className="text-gray-800 fw-bold text-hover-primary mb-1 fs-6 cursor-pointer">
                  {`${row.first_name} ${row.last_name}`}
                </a>
                <span className="text-gray-400 fw-bold d-block fs-7">
                  {row.email.length > 30
                    ? row.email.slice(0, 28) + '...'
                    : row.email}
                </span>
              </div>
            </OverlayTrigger>
          </div>
        </Stack>
      )
    },
    {
      name: t('accounts.team.table.role'),
      show: true,
      sortable: true,
      key: type === COCKPIT ? 'role' : 'cloud_role',

      selector: (row) => (
        <div>
          <RoleIndicator
            role={type === COCKPIT ? row.role : row.cloud_role}
            isOwner={row.is_owner}
          />
        </div>
      )
    },
    {
      name:
        type === COCKPIT
          ? t('accounts.team.table.profile_groups')
          : t('accounts.team.table.cloud'),
      show: true,
      selector: (row) =>
        type === COCKPIT ? (
          <>
            <div
              className="d-flex flex-column mb-2"
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {row.locations_with_access?.length !== 0
                ? row.locations_with_access.map((item) => item.name).join(', ')
                : t('accounts.team.table.all')}
            </div>
            <RolePermissions
              role={type === COCKPIT ? row.role : row.cloud_user_role}
              guestRoles={row.guest_user_permissions}
            />
          </>
        ) : (
          <>
            <div
              className="d-flex flex-column mb-2"
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {row.clouds_with_access?.length !== 0
                ? row.clouds_with_access.map((item) => item.name).join(',')
                : t('accounts.team.table.all')}
            </div>
            <RolePermissions
              role={type === COCKPIT ? row.role : row.cloud_user_role}
              guestRoles={row.guest_user_permissions}
            />
          </>
        )
    },
    {
      name: t('accounts.team.table.join_date'),
      key: 'date_joined',
      sortable: true,
      show: true,
      selector: (row) => (
        <div>
          {new Date(row.date_joined).toLocaleString(currentLang.systemValue, {
            year: '2-digit',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          })}
        </div>
      )
    },
    {
      name: t('accounts.team.table.action'),
      show: true,
      selector: (row) => {
        const [show, setShow] = useState(false);
        const handleDelete = () => {
          dispatch(deleteUser(row.uuid, type, pageNumber, userDeletedCallback));

          setShow(false);
        };
        return (
          <>
            <Modal show={show} onHide={() => {}} size="sm" centered>
              <Modal.Header className="border-0">
                <Modal.Title> {t('accounts.team.table.confirm')}</Modal.Title>
              </Modal.Header>
              <Modal.Body className="border-0">
                {t('accounts.team.table.delete_user_confirmation')}
              </Modal.Body>
              <Modal.Footer className="border-0">
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => setShow(false)}
                >
                  {t('accounts.team.table.close')}
                </Button>
                {!row.is_owner && (
                  <Button variant="danger" size="sm" onClick={handleDelete}>
                    {t('accounts.team.table.delete')}
                  </Button>
                )}
              </Modal.Footer>
            </Modal>

            <Stack gap={1} direction={'horizontal'}>
              {!row.is_owner ? (
                <>
                   <OverlayTrigger
                delayShow={1000}
                overlay={
                  <Tooltip>
                    {t('accounts.team.table.edit_tooltip')}
                  </Tooltip>
                }
              >
                  <Button
                    size="sm"
                    variant="warning"
                    className="badge"
                    onClick={() =>
                      navigate(PATH_PAGE.edit_user.replace(':uuid', row.uuid))
                    }
                  >
                    <i className="fa-duotone fa-pencil text-center fs-5 p-0"></i>
                  </Button>
                   </OverlayTrigger>

                  <OverlayTrigger
                delayShow={1000}
                overlay={
                  <Tooltip>
                    {t('accounts.team.table.delete_tooltip')}
                  </Tooltip>
                }
              >
                  <Button
                    size="sm"
                    variant="danger"
                    className="badge"
                    onClick={() => setShow(true)}
                  >
                    <i className="fa-duotone fa-trash fs-5 p-0"></i>
                  </Button>
                  </OverlayTrigger>
                </>
              ) : (
                '-'
              )}
            </Stack>
          </>
        );
      }
    }
  ];

  // number of rows per page

  const handleRowsPerPageChange = (rowsNumber) => {
    dispatch(changeRowsNumber(rowsNumber, type));
  };
  // redux states
  const {
    [type]: { isLoading, count, currentPageMembers, rowsNumber }
  } = useSelector((state) => state.team);

  // initial load
  const [pageNumber, setPageNumber] = useState(1);
  // get selected page data
  const getSelectedPageData = (pageNumber) => {
    dispatch(getUsersForCurrentPage(pageNumber, type));
    setPageNumber(pageNumber);
  };
  const [search, setSearch] = useState('');

  // for search
  const isMountedRef = useRef(false);
  useEffect(() => {
    if (isMountedRef.current === false) {
      isMountedRef.current = true;
      return;
    }
    const getData = setTimeout(() => {
      dispatch(searchForTeamMembers(search, type));
    }, 500);
    return () => clearTimeout(getData);
  }, [search]);

  const listRef = useRef(null);
  const subHeaderComponentMemo = useMemo(() => {
    const handleSearch = (e) => {
      setSearch(e.target.value);
    };
    return (
      <div className="d-flex justify-content-between w-100 py-5  align-items-center">
        <div>
          <h2 style={{ margin: 0, paddingLeft: 0 }}>
            {type === COCKPIT
              ? t('accounts.team.table.user')
              : t('accounts.team.table.cloud_user')}
          </h2>
        </div>
        <div className="d-flex flex-row align-items-center">
          <div className="d-felx justify-content-end">
            <SearchField onChange={handleSearch} placeholder={t('search')} />
          </div>
        </div>
      </div>
    );
  }, [search, listRef, type]);
  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        color: 'gray'
      }
    },
    table: {
      style: {
        color: 'red',
        backgroundColor: 'gray',
        boxShadow: 'none'
      }
    },
    rows: {
      style: {
        paddingTop: 10,
        paddingBottom: 10,
        '&:not(:last-of-type)': {
          borderBottomStyle: 'dashed'
        }
      }
    },
    headRow: {
      style: {
        paddingTop: 10,
        paddingBottom: 10,

        borderBottomStyle: 'dashed'
      }
    },
    pagination: {
      style: {
        borderTopStyle: 'dashed'
      }
    }
  };
  const handleSort = (row, d) => {
    dispatch(
      getTeamMembers(type, {
        ordering: `${d === 'asc' ? '-' : ''}${row.key}`
      })
    );
    console.log(row, d);
  };

  return (
    <>
      <Toaster />
      <DataTable
        onSort={handleSort}
        sortServer
        columns={columns}
        data={currentPageMembers}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        pagination
        paginationServer
        paginationTotalRows={count}
        onChangePage={getSelectedPageData}
        paginationComponentOptions={{
          rangeSeparatorText: t('accounts.team.table.of'),
          rowsPerPageText: t('accounts.team.table.members_per_page')
        }}
        progressPending={isLoading}
        paginationPerPage={rowsNumber}
        onChangeRowsPerPage={handleRowsPerPageChange}
        progressComponent={<IsLoadingIndicator />}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        customStyles={customStyles}
        noTableCard
        noDataComponent={<T keyName="no_team_members_invite_some"></T>}
      />
    </>
  );
}
